import { render, staticRenderFns } from "./SetQualificationResultAsFailedModal.vue?vue&type=template&id=50cc36e0"
import script from "./SetQualificationResultAsFailedModal.vue?vue&type=script&lang=ts"
export * from "./SetQualificationResultAsFailedModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports